import React, { FC } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmMaintenanceRoDetailsModel } from "../vrmBillMaintenanceRoModel";
import { RouterParamType } from "@/model/navModel";
import { IItemDetailList } from "../vrmBillMaintenanceRoType";
export const ItemTableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailItemLookList } = useVrmMaintenanceRoDetailsModel();
    const title = <>
        <span>维修项目</span>
    </>

    const itemColumn: ColumnsType<IItemDetailList> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '项目名称',
            width: 140,
            dataIndex: 'itemName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '工时',
            width: 120,
            dataIndex: 'workHour',
        }, {
            title: '单价',
            width: 120,
            dataIndex: 'price',
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'itemAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        }, {
            title: '小计',
            width: 120,
            dataIndex: 'receivableAmount',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        }
    ];
    return (
        <YhBox title={title} style={{ marginBottom: "5px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={itemColumn}
                dataSource={detailItemLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}